// extracted by mini-css-extract-plugin
export default {"Desktop":"AppLayout_Desktop__rZk0x","Mobile":"AppLayout_Mobile__0B0Bt","Content":"AppLayout_Content__KZbNY"};